export default __webpack_public_path__ + "ee7ef724c159ab12f8bda8a950dff8ad.png";